import { csatQueryKeys as e } from "./queryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { csatApi as n } from "@maat/api-csat";
import { useAuth as r } from "@maat/store-auth";
//#region src/useCsatEligibilityQuery.ts
var i = 300 * 1e3, a = (a, o) => {
	let { isAuthenticated: s, activeProfile: c } = r();
	return t({
		queryKey: e.eligibility(a),
		queryFn: () => n.getEligibility(a),
		staleTime: i,
		enabled: s && (c === "guest" || c === "host") && (o?.enabled ?? !0)
	});
};
//#endregion
export { a as useCsatEligibilityQuery };
